import { create } from 'zustand';
import { DEVICE_TYPE } from '@tving/utils/src/constants/commonConstants';
import getDeviceType from '@tving/utils/src/utils/common/getDeviceType/getDeviceType';
var deviceType = getDeviceType();
var isCursorVisible = deviceType === DEVICE_TYPE.WEB || (deviceType === DEVICE_TYPE.WEBOS && window.navigator.maxTouchPoints > 0);
var cursor = create(function (set) { return ({
    isCursorVisible: isCursorVisible,
    setCursorVisible: function (isCursorVisible) {
        set(function () { return ({
            isCursorVisible: isCursorVisible,
        }); });
    },
}); });
export var useCursorStore = cursor;
